<template>
  <div>
    <EntityList
      ref="entityList"
      :config="config"
      :columns="columns"
      :custom-query="{product: parentEntity.id}"
      :formatted-columns="formattedColumns"
      :form-fields="formFields"
      authority="Products_Product"
      embedded
      @entity-loaded="handleEntityLoaded"
      @entity-created="handleEntityCreated"
      @entity-updated="handleEntityUpdated"
    />
  </div>
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'
import {
  isAdmin, isSeller, isSupplier, canEditPrice,canEditB2B, getCompanyId,
} from '@/auth/utils'
import storeModule from '../productPricesStoreModule'

export default {
  components: {
    EntityList,
  },
  props: {
    module: {
      type: String,
      required: true,
    },
    parentEntity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sellerOptions: [],
      installmentOptions: [],
      currentEntity: null,
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'product-prices',
        endpoint: 'product-prices',
        route: 'product-prices',
        title: {
          single: this.$t('Price Add'),
          plural: this.$t('Prices'),
        },
      }
    },
    isAdmin() {
      return isAdmin()
    },
    isSupplier() {
      return isSupplier()
    },
    isSeller() {
      return isSeller()
    },
    canEditPrice() {
      return canEditPrice()
    },
    canEditB2B() {
      return canEditB2B()
    },
    companyId() {
      return getCompanyId()
    },
    columns() {
      const columns = [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'regularPrice', label: this.$t('price'), sortable: true },
        { key: 'salePrice', label: this.$t('Sales Price'), sortable: true },
        { key: 'eshopLink', label: this.$t('External Link'), sortable: true },
      ]
      
      if (this.isAdmin) {
        columns.push(
        //  { key: 'b2bData.specialSystem', label: this.$t('Hotel & Contract'), sortable: true },
        //  { key: 'b2bData.minOrder', label: this.$t('Minimum Order'), sortable: true },
         // { key: 'b2bData.deliveryTime', label: this.$t('Delivery Time'), sortable: true },
         // { key: 'b2bData.sellerwarranty', label: this.$t('Warranty'), sortable: true }
        )
      }
      
      if (!this.isSeller) {
        columns.push({ key: 'seller.title', label: this.$t('seller'), sortable: false })
      }
      
      return columns.concat([
        { key: 'quantity', label: this.$t('quantity'), sortable: true },
        { key: 'deliveryReady', label: this.$t('Ready for delivery'), sortable: false },
        { key: 'showroom', label: this.$t('Showroom'), sortable: false },
        { key: 'actions', label: this.$t('actions') },
      ])
    },
    formattedColumns() {
      const formatted = [
        { key: 'deliveryReady', type: 'boolean' },
        { key: 'showroom', type: 'boolean' },
      ]
      
      if (this.isAdmin) {
        formatted.push({ key: 'b2bData.specialSystem', type: 'boolean' })
      }
      
      return formatted
    },
    formFields() {
      const fields = [
        {
          id: 'productId',
          type: 'hidden',
          initVal: this.parentEntity.id,
        },
        {
          id: 'regularPrice',
          type: 'text',
          label: this.$t('price'),
          required: false,
          rules: 'positive',
          colSize: 6,
          readonly: !this.canEditPrice,
        },
        {
          id: 'salePrice',
          type: 'text',
          label: this.$t('salesPrice'),
          rules: 'positive',
          colSize: 6,
          readonly: !this.canEditPrice,
        },
        {
          id: 'saleStartDate',
          type: 'date',
          label: this.$t('saleStartDate'),
          dependency: 'salePrice',
          refMaxDate: 'saleEndDate',
          colSize: 6,
          readonly: !this.canEditPrice,
        },
        {
          id: 'saleEndDate',
          type: 'date',
          label: this.$t('saleEndDate'),
          dependency: 'salePrice',
          refMinDate: 'saleStartDate',
          required: false,
          colSize: 6,
          readonly: !this.canEditPrice,
        },
        {
          id: 'quantity',
          type: 'text',
          label: this.$t('quantity'),
          required: false,
          rules: 'integer',
          colSize: 6,
        },
        {
          id: 'constructionDays',
          type: 'text',
          label: this.$t('Shipping Lead Days'),
          rules: 'integer',
          colSize: 6,
        },
        {
          id: 'deliveryReady',
          type: 'checkbox',
          label: this.$t('Ready for delivery'),
          colSize: 6,
        },
        {
          id: 'showroom',
          type: 'checkbox',
          label: this.$t('Showroom'),
          colSize: 6,
        },
        {
          id: 'customColor',
          type: 'text',
          label: this.$t('Custom Color'),
          colSize: 6,
        },
        {
          id: 'customDimension',
          type: 'text',
          label: this.$t('Custom Dimension'),
          colSize: 6,
        },
        {
          id: 'customFabric',
          type: 'text',
          label: this.$t('Custom Fabric'),
          colSize: 6,
        },
        {
          id: 'eshopLink',
          type: 'text',
          label: this.$t('External Link'),
          colSize: 6,
        },
        {
          id: 'offerStatus',
          type: 'checkbox',
          label: this.$t('Offer Status'),
          colSize: 6,
        },
        {
          id: 'offerEndDate',
          type: 'date',
          label: this.$t('Offer End Date'),
          //dependency: 'salePrice',
          //refMinDate: 'saleStartDate',
          required: false,
          colSize: 6,
          readonly: !this.canEditPrice,
        },
        {
          id: 'offerLink',
          type: 'text',
          label: this.$t('Offer Link'),
          colSize: 12,
        },
        {
          id: 'installmentoption',
          type: 'selectmultiple',
          label: this.$t('Product Installment payment'),
          options: this.installmentOptions,
          colSize: 12,
          readonly: !this.isAdmin,
        },
      ]

      if (this.isAdmin) {
        fields.push(
          {
            id: 'specialSystem',
            parent: 'b2bData',
            type: 'checkbox',
            label: this.$t('Hotel & Contract'),
            colSize: 12,
            initVal: false,
            readonly: !this.canEditB2B,
          },
          {
            id: 'minOrder',
            parent: 'b2bData',
            type: 'text',
            label: this.$t('Seller Minimum Order'),
            colSize: 6,
            dependency: 'specialSystem',
            initVal: '',
            readonly: !this.canEditB2B,
          },
          {
            id: 'deliveryTime',
            parent: 'b2bData',
            type: 'text',
            label: this.$t('Seller Delivery Time'),
            colSize: 6,
            dependency: 'specialSystem',
            initVal: '',
            readonly: !this.canEditB2B,
          },
          {
            id: 'sellerwarranty',
            parent: 'b2bData',
            type: 'text',
            label: this.$t('Seller Warranty'),
            colSize: 6,
            dependency: 'specialSystem',
            initVal: '',
            readonly: !this.canEditB2B,
          }
        )
      }

      if (this.isSeller) {
        fields.push({
          id: 'seller',
          type: 'hidden',
          initVal: { id: this.companyId },
        })
      } else {
        fields.push({
          id: 'seller',
          object: true,
          type: 'select',
          label: this.$i18n.t('Seller'),
          options: this.sellerOptions,
          required: true,
        })
      }
      
      return fields
    },
  },
  mounted() {
    if (!this.isSeller) {
      this.$store.dispatch('app-common/fetchSellers')
        .then(response => {
          this.sellerOptions = response.data
        })
    }
    
    this.installmentOptions = [
      { id: '2_months', title: '2 Months' },
      { id: '4_months', title: '4 Months' },
      { id: '6_months', title: '6 Months' },
      { id: '8_months', title: '8 Months' },
      { id: '10_months', title: '10 Months' },
      { id: '12_months', title: '12 Months' },
      { id: '14_months', title: '14 Months' },
      { id: '16_months', title: '16 Months' },
      { id: '18_months', title: '18 Months' },
      { id: '20_months', title: '20 Months' },
      { id: '22_months', title: '22 Months' },
      { id: '24_months', title: '24 Months' },
    ]

    // Override the save method after component is mounted
    this.overrideSaveMethod()
  },
  methods: {
    overrideSaveMethod() {
      // Wait for the entityList component to be fully mounted
      this.$nextTick(() => {
        if (this.$refs.entityList && this.$refs.entityList.saveEntity) {
          const originalSave = this.$refs.entityList.saveEntity
          
          this.$refs.entityList.saveEntity = async (entityData, isEdit) => {
            try {
              // First call the original save method
              const result = await originalSave.call(this.$refs.entityList, entityData, isEdit)
              
              // Then call B2B API if admin and we have an ID
              if (this.isAdmin && result && result.id) {
                const b2bData = result.b2bData || entityData.b2bData || this.getDefaultB2BData()
                await this.callB2BApi(result.id, b2bData)
              }
              
              return result
            } catch (error) {
              console.error('Error in overridden save:', error)
              throw error
            }
          }
        }
      })
    },

    handleEntityLoaded(entity) {
      if (entity && entity.b2bData === null) {
        entity.b2bData = this.getDefaultB2BData()
      }
      this.currentEntity = entity
    },
    
    handleEntityCreated(entity) {
      if (entity && !entity.b2bData) {
        entity.b2bData = this.getDefaultB2BData()
      }
      this.currentEntity = entity
    },

    handleEntityUpdated(entity) {
      this.currentEntity = entity
    },
    
   /* async callB2BApi(productPriceId, b2bData) {
      try {
        const requestBody = {
          specialSystem: b2bData.specialSystem || false,
          sellerwarranty: b2bData.sellerwarranty || '',
          deliveryTime: b2bData.deliveryTime || '',
          minOrder: b2bData.minOrder || ''
        }
        
        console.log('Calling B2B API with:', requestBody)
        
        // Make the PUT API call to B2B endpoint
        const response = await this.$http.put(
          `http://3.77.64.187:9093/b2b/product-price/${productPriceId}`,
          requestBody
        )
        
        console.log('B2B API call successful:', response.data)
        this.$toast.success(this.$t('B2B data saved successfully'))
        return response.data
        
      } catch (error) {
        console.error('Error calling B2B API:', error)
        this.$toast.error(this.$t('Failed to save B2B data'))
        // Don't throw error here to avoid breaking the main save flow
      }
    },*/
    
    getDefaultB2BData() {
      return {
        specialSystem: false,
        minOrder: '',
        deliveryTime: '',
        sellerwarranty: ''
      }
    }
  },
}
</script>

<style>
#customColor::placeholder,
#customDimension::placeholder,
#customFabric::placeholder,
#eshopLink::placeholder {
  color: transparent;
}

#customColor:focus::placeholder,
#eshopLink:focus::placeholder {
  color: transparent;
}

#customColor:focus-visible,
#customDimension:focus-visible,
#customFabric:focus-visible,
#eshopLink:focus-visible,
#minOrder:focus-visible,
#deliveryTime:focus-visible,
#specialConstructions:focus-visible,
#warranty:focus-visible {
  text-shadow: none;
}

#minOrder:focus-visible::placeholder,
#deliveryTime:focus-visible::placeholder,
#specialConstructions:focus-visible::placeholder,
#warranty:focus-visible::placeholder {
  color: transparent !important;
}
</style>